<div class="container">
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="header">
    <div class="reference">
      @if (commentModel.context.referenceName || commentModel.context.referenceId) {
        <span class="reference-name">
          {{ commentModel.context.referenceName || commentModel.context.referenceId }}
        </span>
      }
      <span class="reference-description">{{ getReferenceTypeKey() | translate }}</span>
    </div>
    <div class="close" (click)="cancel()">
      <i class="material-icons icon">close</i>
    </div>
  </div>

  <div class="flex-row">
    <!-- LEFT -->
    <div class="flex-cell left-cell">
      @if (!videoVisible) {
        <div class="photo" [class.has-preview]="previewUrl">
          <!-- 1. Local preview -->
          @if (previewUrl) {
            <ng-container [ngSwitch]="mimeType">
              <img *ngSwitchCase="'image'" [src]="previewUrl" class="preview-media" />
              <video *ngSwitchCase="'video'" [src]="previewUrl" controls class="preview-media"></video>
              <div *ngSwitchCase="'pdf'" class="preview-generic">
                <i class="material-icons">picture_as_pdf</i>
                <span>PDF preview</span>
              </div>
              <div *ngSwitchDefault class="preview-generic">
                <i class="material-icons">insert_drive_file</i>
                <span>Preview</span>
              </div>
            </ng-container>
          }

          <!-- 2. Existing server attachment -->
          @if (!previewUrl && comment?.attachment?.type) {
            <app-secured-resource
              [workOrderId]="comment.referenceId"
              [commentId]="comment.id"
              [attachmentUrl]="comment.attachment?.url"
              [contentType]="comment.attachment?.type"
              [disabled]="!!previewUrl"
            >
            </app-secured-resource>
          }

          <!-- 4. Camera / Gallery -->
          <div class="attachment-actions">
            <!-- Retake / Replace -->
            @if (isEditing && (previewUrl || comment?.attachment?.type)) {
              <button mat-stroked-button color="primary" (click)="onRetake()">
                <i class="material-icons">photo_camera</i> Retake / Replace
              </button>
            }
            @if (previewUrl) {
              <button mat-button color="warn" (click)="resetAttachment(); onShowCamera()">
                <i class="material-icons">close</i> Remove
              </button>
            }
          </div>
        </div>
      }
      @if (videoVisible) {
        <div class="camera">
          <app-camera
            [videoVisible]="videoVisible"
            [height]="360"
            [width]="380"
            (closeCamera)="onCloseCamera($event)"
            (cancel)="onCancelCamera()"
          >
          </app-camera>
        </div>
      }
    </div>

    <!-- RIGHT -->
    <div class="flex-cell right-cell">
      <div class="text">
        <textarea [(ngModel)]="model.text"></textarea>
      </div>

      <div class="actions">
        <div class="button-wrapper">
          @if (!isEditing) {
            <button mat-flat-button class="cancel-button" (click)="cancel()" [disabled]="loading">
              {{ 'workOrderComments.add.cancel' | translate }}
            </button>
          }
          @if (isEditing) {
            <button mat-flat-button class="cancel-button" (click)="deleteComment()" [disabled]="loading">
              {{ 'workOrderComments.edit.deleteNote' | translate }}
            </button>
          }
        </div>

        <div class="button-wrapper">
          <button mat-flat-button color="primary" (click)="confirm()" [disabled]="loading">
            {{ (isEditing ? 'workOrderComments.edit.saveNote' : 'workOrderComments.add.confirm') | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
